import React, { FC } from 'react';
import { DashboardDropdown } from '@monorepo/nova-ui';
import type { FilterOption, FilterType } from '../../types';
import { DropdownContainer, MobileDropdownContainer } from '../styled';

interface ChartFilterDropdownProps {
  selectedFilter: FilterType;
  filterOptions: FilterOption[];
  onFilterChange: (filter: FilterType) => void;
  mobile?: boolean;
}

/**
 * Chart Filter Dropdown Component
 *
 * Displays the filter dropdown for selecting chart time periods.
 * Handles responsive positioning and filter selection.
 */
export const ChartFilterDropdown: FC<ChartFilterDropdownProps> = ({
  selectedFilter,
  filterOptions,
  onFilterChange,
  mobile = false,
}) => {
  const Container = mobile ? MobileDropdownContainer : DropdownContainer;

  return (
    <Container>
      <DashboardDropdown
        key={selectedFilter}
        options={filterOptions}
        defaultValue={selectedFilter}
        onSelect={onFilterChange}
      />
    </Container>
  );
};
